export class Rights {
  listOfRights: string[];

  constructor() {
    this.listOfRights = [];
  }
}
